export default {
  inserted: (el, binding, vnode) => {
    let _this = vnode.context,
      mousemove = null,
      mouseup = null,
      dis = {
        x: 0,
        y: 0
      },
      dataAction = '';

    mousemove = (e) => {
      let pos = {
        x: e.pageX,
        y: e.pageY
      };

      _this.dragMove && _this.dragMove(pos, dataAction, e);
    };

    mouseup = (e) => {
      document.removeEventListener('mousemove', mousemove);
      document.removeEventListener('mouseup', mouseup);

      let pos = {
        x: e.pageX,
        y: e.pageY
      };

      _this.dragUp && _this.dragUp(pos, dataAction, e);
    };

    el.onmousedown = (e) => {
      dis = {
        x: e.pageX,
        y: e.pageY
      };
      dataAction = e.target.dataset.action;

      if (e.which === 3) {
        e.stopPropagation();
        _this.rightClick && _this.rightClick(dis, dataAction);
        return;
      } else if (e.which === 2) {
        e.stopPropagation();
        _this.middleClick && _this.middleClick(dis, dataAction);
        return;
      }

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);

      _this.dragDown && _this.dragDown(dis, dataAction, e);
    };

    el.oncontextmenu = () => {
      return false;
    };
  },
  unbind(el) {
    el.onmousedown = null;
  }
};
